import { render, staticRenderFns } from "./ProductMicroData.vue?vue&type=template&id=04b737c9&"
import script from "./ProductMicroData.vue?vue&type=script&lang=js&"
export * from "./ProductMicroData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports